var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "primary fill-height d-flex justify-center",
      style: {
        minHeight: "580px",
        backgroundRepeat: "no-repeat",
        backgroundSize: "678px 561px",
        position: "relative",
        overflow: "hidden",
      },
      attrs: { fluid: "", id: "loginContainer" },
    },
    [
      _vm.webPc
        ? _c(
            "div",
            { staticClass: "webPc", staticStyle: { "z-index": "20" } },
            [
              _vm.sendMail
                ? _c(
                    "v-card",
                    { staticClass: "webSendMail", attrs: { elevation: "24" } },
                    [
                      _c("div", { staticClass: "forgot_title text-h3" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("label_Retrieve_password")) + " "
                        ),
                      ]),
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c("v-text-field", {
                            staticStyle: { "margin-top": "40px" },
                            attrs: {
                              label: _vm.$t("label_Company_account"),
                              placeholder: _vm.$t("label_Company_account"),
                              "background-color": "#fff",
                              rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            },
                            on: { keyupEnter: _vm.sendEmailHandler },
                            model: {
                              value: _vm.sendEmailParams.user_account,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sendEmailParams,
                                  "user_account",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "sendEmailParams.user_account",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("CardActions", {
                        staticClass: "mt-7",
                        staticStyle: {
                          height: "48px",
                          "justify-content": "flex-end !important",
                        },
                        attrs: { submitBtn: "", animated: false },
                        on: {
                          cancel: _vm.backHandler,
                          submit: _vm.sendEmailHandler,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "phoneH5" },
            [
              _vm.sendMail
                ? _c(
                    "v-card",
                    { staticClass: "sendMail" },
                    [
                      _c("div", { staticClass: "forgot_title text-h3" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("label_Retrieve_password")) + " "
                        ),
                      ]),
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c("v-text-field", {
                            staticClass: "mt-10",
                            attrs: {
                              label: _vm.$t("label_Company_account"),
                              "background-color": "#fff",
                              rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            },
                            on: { keyupEnter: _vm.sendEmailHandler },
                            model: {
                              value: _vm.sendEmailParams.user_account,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sendEmailParams,
                                  "user_account",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "sendEmailParams.user_account",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("CardActions", {
                        staticStyle: {
                          height: "48px",
                          "justify-content": "flex-end !important",
                        },
                        attrs: { submitBtn: "" },
                        on: {
                          cancel: _vm.backHandler,
                          submit: _vm.sendEmailHandler,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
      _c("svg-icon", {
        staticClass: "left_bg",
        style: {
          left: -_vm.bgstyle / 2 + "px",
        },
        attrs: { size: _vm.bgstyle, iconClass: "left" },
      }),
      _c("svg-icon", {
        staticClass: "right_bg",
        style: {
          right: -_vm.bgstyle / 2 + "px",
        },
        attrs: { size: _vm.bgstyle, iconClass: "right" },
      }),
      _c(
        "v-sheet",
        { staticClass: "text-center footer-container max-width transparent" },
        [
          _c("Footer", {
            attrs: {
              fontColor: "rgba(255, 255, 255, 0.68)",
              contentClass: "pa-0 ma-0 pt-4",
              linkReverse: "",
              center: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }